module.exports = __webpack_public_path__ + "static/media/carulla san fernando-100.bd418273.jpg";